import { WorkletSynthesizer } from "spessasynth_lib";
export class SoundFontSynth {
    context;
    synth = null;
    _loadedSoundFont = null;
    get loadedSoundFont() {
        return this._loadedSoundFont;
    }
    get isLoaded() {
        return this._loadedSoundFont !== null;
    }
    workletModuleAdded = false;
    syxBuffer = [];
    constructor(context) {
        this.context = context;
    }
    async setup() {
        if (this.workletModuleAdded) {
            return;
        }
        this.workletModuleAdded = true;
        const url = new URL("spessasynth_lib/dist/spessasynth_processor.min.js", import.meta.url);
        await this.context.audioWorklet.addModule(url);
    }
    async loadSoundFont(soundFont) {
        // Init synth if needed
        if (this.synth === null) {
            this.synth = new WorkletSynthesizer(this.context);
            this.synth.connect(this.context.destination);
        }
        await this.synth.soundBankManager.addSoundBank(soundFont.data.slice(0), "main");
        this._loadedSoundFont = soundFont;
        await this.synth.isReady;
    }
    handleSysExEvent(e, eventTime) {
        if (this.synth === null)
            return;
        if (e.type === "sysEx")
            this.syxBuffer = [];
        this.syxBuffer.push(...e.data);
        const buf = this.syxBuffer;
        if (buf.length > 0 && buf[buf.length - 1] === 0xf7) {
            this.synth.systemExclusive(buf, 0, { time: eventTime });
            this.syxBuffer = [];
        }
    }
    postSynthMessage(e, eventTime) {
        if (this.synth === null)
            return;
        // Handle sysex separately
        if (e.type === "sysEx" || e.type === "dividedSysEx") {
            this.handleSysExEvent(e, eventTime);
            return;
        }
        if (e.type !== "channel")
            return;
        const ch = e.channel;
        const opts = { time: eventTime };
        switch (e.subtype) {
            case "noteOn":
                this.synth.noteOn(ch, e.noteNumber, e.velocity, opts);
                break;
            case "noteOff":
                this.synth.noteOff(ch, e.noteNumber, opts);
                break;
            case "channelAftertouch":
                this.synth.channelPressure(ch, e.amount, opts);
                break;
            case "controller":
                this.synth.controllerChange(ch, e.controllerType, e.value, opts);
                break;
            case "noteAftertouch":
                this.synth.polyPressure(ch, e.noteNumber, e.amount, opts);
                break;
            case "pitchBend":
                this.synth.pitchWheel(ch, e.value, opts);
                break;
            case "programChange":
                this.synth.programChange(ch, e.value, opts);
                break;
        }
    }
    sendEvent(event, delayTime = 0, _timestampNow = performance.now(), _trackId) {
        if (!this.synth)
            return;
        const eventTime = this.synth.currentTime + delayTime;
        this.postSynthMessage(event, eventTime);
    }
    activate() {
        this.context.resume();
    }
    stopAll() {
        this.synth?.stopAll(true);
    }
}
//# sourceMappingURL=SoundFontSynth.js.map